import React from 'react';
import { useLocation } from 'react-router-dom';
import TopNavigation from './TopNavigation';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  
  // Obtener la página actual desde la URL
  const getCurrentPage = () => {
    const path = location.pathname.split('/')[1];
    return path || 'dashboard';
  };

  return (
    <div className="min-h-screen bg-[#fafafa] dark:bg-gray-900 ">
      <TopNavigation currentPage={getCurrentPage()} />
      <main className="pt-20 pb-12">
        {children}
      </main>
    </div>
  );
};

export default Layout;